import React, { useCallback, useRef, useEffect, useState } from 'react';

import { Form } from '@unform/web';
import { Container } from './styles';
import { hour, dateLanguage, day, monthNumber, dateLanguageHour } from '../../../../utils/date';
import api from '../../../../services/api';
import Vimeo from '../../../../components/Vimeo';

import PosterZoomComponent from '../../../../components/CientificLibraryRoom';
import { Button } from '../../../../components/Button/styles';
import { rgb, rgba } from 'polished';
import Favorite from '../../../../components/ClassRoomContainer/modules/Favorite';
import { FaBook, FaSearch, FaStar } from 'react-icons/fa';
import { useLanguage } from '../../../../hooks/Language';
import { string } from 'yup';
import themeDefault from '../../../../styles/ThemeComponents';
import { hash, urlWebsite } from '../../../../config';
import { useAuth } from '../../../../hooks/Auth';
import { useParams, useHistory, Link } from 'react-router-dom';
import { addDays, endOfDay, getDay, startOfDay } from 'date-fns';
import SliderComponent from '../../../../components/Slider';
import { Capa } from '../../../ListarEventos/styles';
import { loadFromJson } from '../../../../utils/loadFromJson';

interface IPoster {
  _id: string;
  keywords: Array<string>;
  star?: number;
  title?: string;
  nested_authors?: string;
  author?: string;
  image?: string;
  video_type?: number;
  video_id: string;
  co_authors?: string;
  category?: string;
  have_video?: number;
  eixo?: string;
  pdf?: string;
  pdf_image?: Array<Record<string, any>>;
  time_to_read?: string;
}

interface IPosters {
  next: Array<IPoster>;
  nextLives: Array<IPoster>;
  prev: Array<IPoster>;
  highlight: Array<IPoster>;
}

interface IOption {
  page: number;
  order: Record<string, string>;
  where: Record<string, any>;
  eixo?: string;
}

interface IStars {
  stars: number;
}



export const track = ({ id = '', title = '', reference = '', track = '', client_id = '', client_name }) => {

  /* ID do trabalho
  titulo do trabalho
  reference é a ação
  track o que é
  
  */

  // api.post('/add-track', { id, title, reference, track , client_id : client_id, client_name, project_id: 'cientific-library' });


}

export const ShowStars: React.FC<IStars> = ({ stars = 5 }) => {

  return <div className='starCase'>

    <FaStar size={15} style={{ color: stars >= 1 ? 'rgb(25, 73, 143)' : '#fff' }} />
    <FaStar size={15} style={{ color: stars >= 2 ? 'rgb(25, 73, 143)' : '#fff' }} />
    <FaStar size={15} style={{ color: stars >= 3 ? 'rgb(25, 73, 143)' : '#fff' }} />
    <FaStar size={15} style={{ color: stars >= 4 ? 'rgb(25, 73, 143)' : '#fff' }} />
    <FaStar size={15} style={{ color: stars >= 5 ? 'rgb(25, 73, 143)' : '#fff' }} />
  </div>

}

interface IProps {
  allowed?: Array<string>;
}

interface IPropsDisplay {
  posters?: IPosters;
  type?: string;
  title?: string;
  search?: string;
}


const DisplayEvents: React.FC<IPropsDisplay> = ({ search = '', posters, type = 'next', title = 'Próximos eventos' }) => {
  const { language } = useLanguage();
  const getColor = categoryName => {
    if (categoryName === 'Apresentação Oral') {
      return 'borderBlue';
    }
    if (categoryName === 'Pôster Comentado') {
      return 'borderPurple';
    }
    if (categoryName === 'Pôster Simples') {
      return 'borderGreen';
    }
  };

  const item = posters?.[type] ? posters?.[type] : [];



  const [items, setItems] = useState<Array<JSX.Element>>([]);

  useEffect(() => {

    const newItems: Array<JSX.Element> = [];


    if (item && type === 'prev') {



      item.sort((a, b) => {

        const dateA = a.start_at ? new Date(a.start_at) : new Date();
        const dateB = b.start_at ? new Date(b.start_at) : new Date();

        return dateA < dateB ? 1 : dateA > dateB ? -1 : 0


      });
    }


    item.map(poster => {
      if (search) {

        const newsearch = search.toLowerCase();

        const index = poster?.title?.toLowerCase()?.indexOf(newsearch) >= 0 || poster?.date_text?.toLowerCase()?.indexOf(newsearch) >= 0;

        if (!index) {
          return;
        }

      }
      newItems.push(<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', maxWidth: 'auto' }}>
        <Link to={`/app/${poster.project_id}`} key={`posterDiv${poster._id}`} style={{ position: 'relative' }}
          className={`posterDisplay ${getColor(poster.category)}`}

        >

          <div className='posterImageDiv'>
            {poster.image ?
              <img key={`img-${poster._id}`}
                className="posterImage"
                src={poster.image ? `${urlWebsite}/${poster.image}` : '/apoio/biblioteca/capa.jpeg'}
              /> : <div className='eventTitle'><h2>
                {poster?.[`title_${language}`] ? poster?.[`title_${language}`] : poster?.title}
              </h2></div>}
          </div>

          <div className='typeButtonDiv'>
            <button className='typeButtonInitial'>{poster.project_id === 'lives' ? 'Live' : 'Evento'}</button>
            <button className='typeButton'>{type === 'next' ? 'Inscrições Abertas' : 'Realizados'}</button>

          </div>

        </Link>

      </div>)
    });

    setItems(newItems);

  }, [item, search])
  if (items.length < 1) {
    return <></>
  }

  return <> <div className='posterHeader' >

    {title && <h1>{title}</h1>}

  </div>

    <div className="mainPoster">
      {items}

    </div>
  </>



}



const EventsFullListDisplay: React.FC<IProps> = () => {
  const [posters, setPosters] = useState<IPosters>({ next: [], nextLives: [], prev: [], highlight: [] });
  const [selectedPoster, setSelectedPoster] = useState<string>('');
  const { categoryName } = useParams<Record<string, any>>();
  const { posterid, eixo } = useParams<Record<string, any>>();
  const [allowed, setAllowed] = useState(['next', 'nextLives', 'prev', 'highlight']);
  const [openPoster, setOpenPoster] = useState(false);
  const [loading, setLoading] = useState(true);
  const [counter, setCounter] = useState(1);

  const [searchOption, setSearchOption] = useState('');

  const [haveSelector, setHaveSelector] = useState(false);

  const [eixos, setEixos] = useState<Array<string>>([]);
  const { user } = useAuth();
  const [options, setOptions] = useState<IOption>({
    page: 1,
    order: { orderBy: 'createdAt', direction: 'desc' },
    where: {},
    eixo: ''
  });
  const { translate } = useLanguage();

  const [currentCategory, setCurrentCategory] = useState('');
  const [search, setSearch] = useState('');

  useEffect(() => {



    if (categoryName) {
      setCurrentCategory(categoryName);
      setAllowed([categoryName]);
    }

    const searchValue = new URLSearchParams(window.location.search).get("search");

    if (searchValue) {

      setSearch(searchValue);
      setSearchOption(searchValue);
    }


  }, [])


  useEffect(() => {
    if (categoryName) {
      setCurrentCategory(categoryName);
      setAllowed([categoryName]);
    }
    else {
      setAllowed(['next', 'nextLives', 'prev', 'highlight']);
    }
  }, [categoryName])


  useEffect(() => {
    if (currentCategory) {

      setAllowed([currentCategory]);
    }
    else {
      setAllowed(['next', 'nextLives', 'prev', 'highlight']);
    }
  }, [currentCategory])

  useEffect(() => {

    if (posterid) {
      setSelectedPoster(posterid);
      setOpenPoster(true);
    }

  }, [posterid])


  const { push } = useHistory();


  const changeEixo = (value) => {

    const newOptions = { ...options };

    newOptions.eixo = value;

    setOptions(newOptions);
    if (value) {
      push(`/biblioteca-cientifica/categoria/${value}`);
    }
    else {
      push(`/biblioteca-cientifica`);
    }

    loadSearch({ listOptions: newOptions });

  }


  const loadSearch = async ({ join = false, page = 0, text = '', listOptions }) => {

    const newOptions = listOptions?.page ? { ...listOptions } : { ...options };

    const string = `search=${encodeURIComponent(
      text || search || '',
    )}&order=${encodeURIComponent(JSON.stringify(newOptions.order))}&page=${page > 0 ? page : newOptions.page
      }&where=${encodeURIComponent(JSON.stringify(newOptions.where))}&eixo=${encodeURIComponent(newOptions.eixo || '')}`;



    let data: Array<Record<string, any>> = [];

    const events = await loadFromJson({ hash: hash, project_id: 'global', table: 'Event' });

    if (events) {
      data = events;
      data.sort((a, b) => {
        const dateA = new Date(a.start_at);
        const dateB = new Date(b.start_at);
        return dateA > dateB ? 1 : dateA < dateB ? -1 : 0;
      })
    }
    else {

      const response = await api.get(`/events-list?${string}`);
      data = response?.data?.rows;
    }

    const date = addDays(new Date(), -1);

    if (data) {
      const responseData = { next: [], nextLives: [], highlight: [], prev: [] };


      data.map((elem) => {
        elem.formatted_date = dateLanguage(elem.date);
        elem.formatted_start_hour = hour(elem.start_at);
        elem.formatted_end_hour = hour(elem.end_hour);
        if (!elem.keywords) {
          elem.keywords = [];
        }

        const eventDate = new Date(elem.start_at);

        // let state = date > startOfDay(eventDate) && date < endOfDay(eventDate) ? 'highlight' :  date < eventDate ? 'next' : 'prev';
        let state = date < eventDate ? 'next' : 'prev';


        if (state === 'next' && elem.project_id === 'lives') {
          state = 'nextLives';
        }



        responseData?.[state].push(elem);

      });


      if (responseData?.prev?.length > 0) {
        responseData?.prev.reverse();

      }




      if (join) {
        const newPosters = { ...posters };
        newPosters.next = [...newPosters.next, ...responseData.next];
        newPosters.nextLives = [...newPosters.nextLives, ...responseData.nextLives];
        newPosters.prev = [...newPosters.prev, ...responseData.prev];
        newPosters.highlight = [...newPosters.highlight, ...responseData.highlight];

        setPosters({ ...newPosters });
      } else {
        setPosters({ ...responseData });
      }

      setCounter(data.length / 20 < 1 ? 1 : data.length / 20);


      //  readEixos(response.data.rows);

    } else {
      setPosters({ next: [], nextLives: [], prev: [], highlight: [] });
      setCounter(1);
    }
    setLoading(false);
  };




  const load = async () => {

    const newOptions = { ...options };
    if (eixo) {


      newOptions.eixo = eixo;

      setOptions(newOptions);
    }


    loadSearch({ listOptions: newOptions });
  };



  useEffect(() => {


    load();

    track({ id: '', title: 'Área de eventos', reference: 'Visita', track: 'Acesso', client_name: user?.name || '', client_id: user?.id || '' })
  }, []);











  const list = {
    highlight: { title: 'Clique para acessar', type: 'highlight' },
    next: { title: 'Próximos eventos', type: 'next' },
    nextLives: { title: '', type: 'nextLives' },
    prev: { title: 'On Demand', type: 'prev' }

  }

  const changeSearch = () => {
    console.log(search);
    setSearchOption(search);
  }


  return (
    <Container>
      <Capa style={{ minHeight: 'auto', marginBottom: '25px' }}>
        <div className='p50 homeTitle  ' >
          <div className='searchDivStart'>
            <select onChange={(e) => setCurrentCategory(e.target.value)} className='homeSelect'>
              <option selected={currentCategory === ""} value={""}>Todas as categorias</option>
              <option selected={currentCategory === "next"} value={"next"}>Próximos eventos</option>
              <option selected={currentCategory === "prev"} value={"prev"}>On Demand</option>
            </select>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <input className='homeSelect' value={search} onChange={(e) => {
                setSearch(e.target.value);


              }} onKeyUp={(e) => {
                if (e.key === "Enter") {
                  changeSearch();
                }
              }} name="search" placeholder='Pesquisar' />

              <button type="button" className='homeSelectReverse' onClick={() => changeSearch()}><FaSearch /></button>
            </div>
          </div>
        </div>

        <div className='p50 homeTitle'>

        </div>

      </Capa>

      <Capa  >

        <div style={{ width: '100%', margin: '0px' }}>
          {allowed.map(allow => {
            return list?.[allow] ? <DisplayEvents key={`event-${allow}`} search={searchOption} posters={posters} type={list?.[allow].type} title={list?.[allow].title} /> : <></>


          })}


        </div>


      </Capa>

    </Container>
  );
};
export default EventsFullListDisplay;
